import * as R from 'remeda';
import { SchemaItem, SchemaSection } from '@rossum/api-client/schemas';

export const isValidFieldId = (id: string) =>
  !/^\d/.test(id) && !id.includes('-');

export const getSchemaFields = (
  obj: SchemaSection | SchemaItem | Array<SchemaSection> | Array<SchemaItem>,
  isInsideMultivalue = false,
  section?: string
): Array<
  (SchemaSection | SchemaItem) & {
    isInsideMultivalue: boolean;
    section?: string;
  }
> =>
  'children' in obj && obj.children
    ? [
        [{ ...obj, isInsideMultivalue, section }],
        ...getSchemaFields(
          obj.children,
          isInsideMultivalue || obj.category === 'multivalue',
          obj.category === 'section' ? obj.label : section
        ),
      ].flat()
    : Array.isArray(obj)
      ? obj.flatMap(item => getSchemaFields(item, isInsideMultivalue, section))
      : [{ ...obj, isInsideMultivalue, section }];

export const getNonTupleSchemaFields = (content: SchemaSection[]) => {
  return R.pipe(
    content,
    getSchemaFields,
    R.flatMap(item => (item.category !== 'tuple' ? [item] : []))
  );
};

export const getValidSchemaFields = (
  schema: SchemaSection | SchemaItem | Array<SchemaSection> | Array<SchemaItem>
) => {
  return getSchemaFields(schema).filter(({ id }) =>
    id ? isValidFieldId(id) : false
  );
};
